import { Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';
import { EnterToSubmitMode } from './hooks/useEnterToSubmit';
import { useEnterToSubmitFocusContainer } from './hooks/useEnterToSubmitFocusContainer';

type EnterToSubmitFocusContainerProps = {
  children: ReactNode;
  /** Submit mode. Defaults to `auto`. */
  mode?: EnterToSubmitMode;
  /** When false, Enter shortcuts do nothing. Defaults to true. */
  enabled?: boolean;
  /** When true, focuses the container on mount. Defaults to true. */
  focusOnMount?: boolean;
  sx?: BoxProps['sx'];
};

/**
 * Focusable panel wrapper that owns enter-to-submit shortcuts when fields are not focused.
 * Place inside or around an AppForm so keydown can resolve the form element.
 */
export function EnterToSubmitFocusContainer({
  children,
  mode = 'auto',
  enabled = true,
  focusOnMount = true,
  sx,
}: EnterToSubmitFocusContainerProps) {
  const { ref, tabIndex, onKeyDown, onMouseDown } = useEnterToSubmitFocusContainer({
    mode,
    enabled,
    focusOnMount,
  });

  return (
    <Box
      ref={ref}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      onMouseDown={onMouseDown}
      sx={[{ outline: 'none' }, sx]}
    >
      {children}
    </Box>
  );
}
